import { render, staticRenderFns } from "./LanguagesForm.vue?vue&type=template&id=52998a6a&"
import script from "./LanguagesForm.vue?vue&type=script&lang=js&"
export * from "./LanguagesForm.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesForm.vue?vue&type=style&index=0&id=52998a6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports